import createTheme from 'spectacle/lib/themes/default';

const theme = createTheme(
  {
    primary: 'white',
    secondary: '#1F2022',
    tertiary: '#03A9FC',
    quartenary: '#C4C4C4',
  },
  {
    primary: 'Montserrat',
    secondary: 'Helvetica',
  }
)

export default theme




// WEBPACK FOOTER //
// ./src/theme.js